import { Component, Input, OnInit } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-no-data-message',
  templateUrl: './no-data-message.component.html',
  styleUrls: ['./no-data-message.component.scss'],
  standalone: true,
  // imports: [LottieModule],
})
export class NoDataMessageComponent implements OnInit {
  @Input() message: string = '';
  @Input() type: string = 'default';
  options: AnimationOptions = {
    path: '../../../assets/other/loading_lottie.json',
  };

  constructor() {}

  ngOnInit(): void {}

  // This is the component function that binds to the animationCreated event from the package
  onAnimate(animationItem: AnimationItem): void {
  }}
